import { FC } from 'react';
import { SVGIconType } from '../assets/types';
import { ReportType, SavingsPlanFrequency } from '@bts-web/data-layer/server';

export enum OnboardingQuestionnaireType {
  CLASSIC = 'CLASSIC',
  CORPORATE = 'CORPORATE',
}

export type CURRENCY = 'EUR' | 'AED' | 'GBP';

export type Apps =
  | 'Raiffeisen'
  | 'LBBW'
  | 'Rakbank'
  | 'SGForge'
  | 'Ribbon'
  | 'Raiffeisen Tirol'
  | 'Raiffeisen Steiermark'
  | 'Raiffeisen Salzburg'
  | 'Raiffeisen Vorarlberg'
  | 'BFOR'
  | 'BW Bank'
  | 'iCard';

export type AppConfig = {
  appId: number;
  appName: Apps;
  /** Lowercase slug for Lokalise tenant keys: `{base}_@tenant_{suffix}`. Must not contain spaces. */
  tenantTranslationKeySuffix: string;
  arePdfsOpenedAsLinks?: boolean;
  // Terms & conditions documents use the browser's native handling instead of the Google PDF viewer (desktop only)
  useNativeTermsPreviewOnDesktop?: boolean;
  isByol?: boolean;
  partnerHostAppName?: string;
  // these two values are either false or a string, which is a translation key for the Tfunction
  additionalSellConfirmationText?: string;
  additionalBuyConfirmationText?: string;
  bitpandaAcademyPageUrl?: string;
  classicOnboardingSuccessfulMessageType?:
    | 'withRiskDisclosure'
    | 'withoutRiskDisclosure';
  disableLogoutButton?: boolean;
  localPublicFolderPathTo_FAQDocument?: string;
  URLforCustomerSupport?: string;
  supportPhoneNumber?: string;
  supportEmail?: string;
  savingsPlansFrequencySelection?: SavingsPlanFrequency[];
  currency: CURRENCY;
  useLegacyOperationUrls?: boolean;
  appLogo: FC<SVGIconType> | 'wbr';
  appLogoInverted?: FC<SVGIconType>;
  bankLogo?: FC<SVGIconType>;
  landingPageLangIconColorScheme: 'dark' | 'light';
  minimumFiatTradeAmountForSingleCurrency?: number;
  minimumSavingsAmount?: number;
  minimumCalendarDaysBeforeExecution?: number;
  paymentDaysBeforeExecution?: number;
  maxDaysFromMonthEndForSavingsExecution?: number;
  onboardingType: OnboardingQuestionnaireType;
  isUAETenant?: boolean;
  improvedTracing?: boolean;
  supportedLanguages: string[];
  islamicComplianceUrl?: string;
  reportsTypeFilterItems?: ('ALL' | ReportType)[];
  settlementType?: 'TYPE_1' | 'TYPE_2' | 'TYPE_3';
  automaticWithdrawalsDefaultEnabled?: boolean;
  // Hides the DAC8 tax-details flow for tenants that already collect this info themselves during onboarding
  disableDac8?: boolean;
  welcomeContinueButtonVisual: 'primary' | 'secondary';
  welcomeScreenBadgesVisual: 'filledNeutralDark' | 'outlineNeutralDark';
  welcomeScreenInfoLayoutVariant?: 'default' | 'primary';
  onboardingSuccessfulInfoLayoutVariant?:
    | 'default'
    | 'primary'
    | 'dark'
    | 'light';
  skipWelcomePage?: boolean;
};
